import React, { useState } from 'react';
import { Button, MenuItem, Select, Grid, Typography, Box } from '@mui/material';
import { useNavigate, Outlet } from 'react-router-dom';
import '../../App.css';

function Requests() {
    const navigate = useNavigate();
    const [selectedButton, setSelectedButton] = useState('myads');
    const gotoPostAd = () => {
        navigate('/postad');
    };
    return (
        <div style={{ position: 'relative' }}>
            {/* <Typography
                sx={{
                    position: 'absolute',
                    top: '-40px',
                    left: '0px'
                }}
            >
                Redeem Requests
            </Typography>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                    marginTop: '5px'
                }}
            >
                <div>
                    <Button
                        variant="contained"
                        size="small"
                        className={
                            selectedButton === 'myads'
                                ? 'btnSelectedStyle'
                                : 'btnStyle'
                        }
                        sx={{
                            height: '30px',
                            padding: '0px 20px',
                            borderRadius: '4px'
                        }}
                        onClick={e => {
                            setSelectedButton('myads');
                            navigate('redeemrequests');
                        }}
                    >
                        Redeem Requests
                    </Button>

                    <Button
                        variant="contained"
                        className={
                            selectedButton === 'requests'
                                ? 'btnSelectedStyle'
                                : 'btnStyle'
                        }
                        size="small"
                        sx={{
                            height: '30px',
                            padding: '0px 20px',
                            borderRadius: '4px'
                        }}
                        style={{ marginLeft: '10px' }}
                        onClick={e => {
                            setSelectedButton('requests');
                            navigate('refundrequests');
                        }}
                    >
                        Refund Requests
                    </Button>
                </div>
            </div> */}
            <Outlet />
        </div>
    );
}

export default Requests;
